export default __webpack_public_path__ + "static/media/saturn.00f31af2.png";